module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.duplicate) ? _c('v-alert', {
    attrs: {
      "dense": "",
      "text": "",
      "dismissible": "",
      "icon": "offline_bolt",
      "type": "warning"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.duplicate.firstName) + " " + _vm._s(_vm.duplicate.lastName) + " (" + _vm._s(_vm.duplicate.email) + ") already exists. Only proceed if you are sure this is not a duplicate.\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f555f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/UniqueContactEnforcer.vue
// module id = 2500
// module chunks = 1